<div class="shop-grid">
    @for(searchResult of searchResults; track searchResult.productId){
        <div class="grid-item">
            <app-search-result-item [searchResult]="searchResult" [showSaveAction]="showSaveAction" ></app-search-result-item>
        </div>
    }
</div>
